module.exports = __webpack_public_path__ + "img/row-img3.b034179b.png";